<div class="password-reset-page">
  <app-password-reset-box></app-password-reset-box>
</div>
